export const TXP_OPTIONS_V2_FEATURE = 'cal-txp-optionsV2';
export const GRIFFIN_REQUEST_BASEURL = 'txp/api/v1.0/me/{0}';
export const GRIFFIN_REQUEST_UNBLOCK = 'txp/api/v1.0/Users/me/{0}';
export const USER_SETTINGS = 'UserSettings';
export const UNBLOCK = 'Unblock';

// Datapoint names

export const TxpSettingsDataPointNames = {
    // name for datapoint which logs TXP loading settings.
    TXPSettingsLoad: 'TxpSettingsLoad',

    //name for datapoint which logs Txp setting response is error.
    TXPSettingsResponseError: 'TXPSettingsResponseError',

    // name for datapoint which logs TXP settings save V2
    TxpSettingsSaveV2: 'TxpSettingsSaveV2',

    // name for datapoint which logs when the user has turned off their autoblocked status
    TxpUnblock: 'TxpUnblock',
};
